import { makeLocalFavoriteStore } from 'Workspace/storage/makeLocalFavoriteStore';

const store = makeLocalFavoriteStore({
  favoriteKeysPrefix: 'workspace.courseware.favoriteProjectIds',
  allExpandedPrefix: 'workspace.courseware.allProjectsExpanded',
  favoriteKeysParseErrorLabel: 'Failed to parse stored workspace favorite project ids',
  allExpandedParseErrorLabel: 'Failed to parse stored all projects expanded state',
});

export const getWorkspaceFavoriteProjectIdsStorageKey = store.getFavoriteKeysStorageKey;
export const getAllProjectsExpandedStorageKey = store.getAllExpandedStorageKey;
export const loadFavoriteProjectIds = store.loadFavoriteKeys;
export const saveFavoriteProjectIds = store.saveFavoriteKeys;
export const loadAllProjectsExpanded = store.loadAllExpanded;
export const saveAllProjectsExpanded = store.saveAllExpanded;
